










































































import { Component, Mixins } from "vue-property-decorator";
import MultiProfessionListUserFilter from "../../../filters/wizard/guest/MultiProfessionListUserFilter.vue";
import DepartmentListUserFilter from "../../../filters/wizard/guest/DepartmentListUserFilter.vue";
import MultiOrderableUserListSelector from "../../../selectors/MultiOrderableUserListSelector.vue";
import UserDetailViewer from "../../../viewers/UserDetailViewer.vue";
import { MultiOrderableUserListSelectorDialogMixin } from "../../mixins";

@Component({
  components: {
    MultiProfessionListUserFilter,
    DepartmentListUserFilter,
    MultiOrderableUserListSelector,
    UserDetailViewer,
  },
})
export default class MultiOrderableUserListSelectorDialog extends Mixins(MultiOrderableUserListSelectorDialogMixin) {
}
